import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper';

import { theme } from '_constants/theme';
import Testimonial from '_components/atomic/Testimonial';

const { colors, devices, fontSizes, spaces } = theme;

const StyledTestimonialsSection = styled.div`
  max-width: ${spaces.large24X * 10 + 80}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .headerSection {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-size: ${fontSizes.large11X}px;
    line-height: 130%;
    text-align: center;
    color: ${colors.gray[800]};
    align-self: stretch;
  }
  .columnDesktopContainer {
    display: flex;
    margin-top: ${spaces.large4X}px;
    gap: 30px;
  }
  .columnMobileContainer {
    display: none;
  }
  @media ${devices.tablet} {
    margin-left: 0;
    margin-right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0px;
    .headerSection {
      padding: 0px ${spaces.regular}px;
      font-size: ${fontSizes.large2X}px;
      line-height: 150%;
    }
    .columnDesktopContainer {
      display: none;
    }
    .columnMobileContainer {
      display: block;
      width: 100%;
      margin-top: ${spaces.large}px;
      padding-left: ${spaces.regular}px;
      padding-right: ${spaces.regular}px;
      .swiper-pagination {
        position: relative;
      }
      .swiper-pagination-bullet-active {
        background: ${colors.indigo[500]};
      }
    }
    .swiper-slide {
      width: 90%;
      height: auto !important;
    }
  }
`;
const StyledTestimonial = styled.div`
  width: 33%;
  @media ${devices.tablet} {
    width: initial;
    height: 100%;
  }
`;
const TestimonialsSection = ({ title, testimonials }) => {
  return (
    <StyledTestimonialsSection>
      <div className="headerSection">{title}</div>
      <div className="columnDesktopContainer">
        {testimonials.map((testimonial, idx) => {
          const { description, author, title } = testimonial;
          return (
            <React.Fragment key={`testimonial:${idx}`}>
              <StyledTestimonial>
                <Testimonial
                  description={description}
                  author={author}
                  title={title}
                />
              </StyledTestimonial>
            </React.Fragment>
          );
        })}
      </div>
      <div className="columnMobileContainer">
        <Swiper
          modules={[Pagination]}
          pagination={{
            clickable: true,
          }}
        >
          {testimonials.map((testimonial, idx) => {
            const { description, author, title } = testimonial;
            return (
              <SwiperSlide key={`testimonial:${idx}`}>
                <StyledTestimonial>
                  <Testimonial
                    description={description}
                    author={author}
                    title={title}
                  />
                </StyledTestimonial>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </StyledTestimonialsSection>
  );
};

TestimonialsSection.propTypes = {
  title: PropTypes.node,
  testimonials: PropTypes.arrayOf(
    PropTypes.shape({
      author: PropTypes.node,
      title: PropTypes.node,
      description: PropTypes.node,
    })
  ),
};

export default TestimonialsSection;
